export default () => ({
	path: 'privacy',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./component').default;
					cb(null, component);
				},
				'Privacy',
			),
	},
});



// WEBPACK FOOTER //
// ./src/routes/Privacy/index.js